module.exports = __webpack_public_path__ + "img/intestinal.01aa7048.svg";